export default "__VITE_ASSET__DnJ6qv1$__"